import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectors } from "reducers/patient-outreaches";
import { setPage, setPageSize } from "actions/patient-outreaches";

const PAGE_SIZE_OPTIONS = [25, 50, 100];

const PaginationFooter = () => {
  const dispatch = useDispatch();
  const page = useSelector(selectors.getPage);
  const pageSize = useSelector(selectors.getPageSize);
  const totalMatching = useSelector(selectors.getTotalMatching);

  const totalPages = Math.max(1, Math.ceil(totalMatching / pageSize));
  const start = totalMatching === 0 ? 0 : (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, totalMatching);

  return (
    <div className="patient-outreach-pagination">
      <span className="patient-outreach-pagination__summary">
        Showing {start}–{end} of {totalMatching}
      </span>

      <div className="patient-outreach-pagination__controls">
        <button
          type="button"
          onClick={() => dispatch(setPage(Math.max(1, page - 1)))}
          disabled={page <= 1}
        >
          ‹ Prev
        </button>
        <span>
          Page {page} of {totalPages}
        </span>
        <button
          type="button"
          onClick={() => dispatch(setPage(Math.min(totalPages, page + 1)))}
          disabled={page >= totalPages}
        >
          Next ›
        </button>
      </div>

      <label className="patient-outreach-pagination__page-size">
        Page size:{" "}
        <select
          value={pageSize}
          onChange={e => dispatch(setPageSize(Number(e.target.value)))}
        >
          {PAGE_SIZE_OPTIONS.map(opt => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
};

export default PaginationFooter;
